import { render, staticRenderFns } from "./modifyPwd.vue?vue&type=template&id=d38a43f8"
import script from "./modifyPwd.vue?vue&type=script&lang=js"
export * from "./modifyPwd.vue?vue&type=script&lang=js"
import style0 from "./modifyPwd.vue?vue&type=style&index=0&id=d38a43f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports